import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useAuthStore } from "@/stores";
import type IEntraLogin from "@/models/responses/IEntraLogin";

export const useEntraLoginsStore = defineStore("entraLogins", {
  state: () => ({
    error: "" as any,
    data: [] as IEntraLogin[],
    loadedUserId: 0 as number | undefined,
  }),
  actions: {
    async fetchAll(force = false) {
      const authStore = useAuthStore();
      const { isAuthenticated, user } = storeToRefs(authStore);

      if (!isAuthenticated.value) return;
      if (!force && this.loadedUserId === user.value?.id) return;

      this.error = "";
      await api
        .get<IEntraLogin[]>("v1.0/auth-entra/logins")
        .then((response) => {
          this.data = response.data;
          this.loadedUserId = user.value?.id;
        })
        .catch((error) => (this.error = error));
    },
    async delete(id: number) {
      await api
        .delete(`v1.0/auth-entra/logins/${id}`)
        .then(() => {
          const index = this.data.findIndex((x) => x.id === id);
          if (index !== -1) this.data.splice(index, 1);
        })
        .catch((error) => (this.error = error));
    },
  },
  getters: {
    getById:
      (state) =>
      (id: number): IEntraLogin => {
        return <IEntraLogin>state.data.find((item) => item.id === id);
      },
  },
});
